module.exports = __webpack_public_path__ + "static/ebca3d24.right.png";